import { Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { appPaths } from '../../../app.paths';
import { RouterModule } from '@angular/router';

@Component({
  selector: '[findings]',
  imports: [RouterModule, ContainerComponent, GlobalButtonComponent],
  templateUrl: './findings.component.html',
  styleUrl: './findings.component.scss',
  host: {
    id: 'what-patients-say',
  },
})
export class FindingsComponent {
  cardButton = {
    buttonLabel: 'Download full survey results',
    buttonUrl: 'assets/pdf/cost-of-not-knowing-survey-results.pdf',
    openInNewTab: true,
    buttonIcon: 'download-icon',
  };
}
